export const SERVICE = 'PRODUCTS'
